import { Card, View } from '@acin/ui-core';
import styled from 'styled-components';

export const ReviewObligations = styled(View)`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100vh;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
`;

export const Columns = styled(View)`
  display: flex;
  flex-direction: row;
  gap: ${(p) => p.theme.spacing.getSize(4)};
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const LeftColumn = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 365px;
  min-width: 365px;
  min-height: 0;
  overflow: hidden;
  padding: 0;
`;

export const ColumnHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: ${(p) => p.theme.spacing.getSize(4)};
  border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(3)};
  box-sizing: border-box;
  flex-shrink: 0;
`;

export const RightColumns = styled(Card)`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  padding: 0;
`;

export const SplitContent = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  min-height: 0;
  overflow: hidden;
`;

export const RulesSection = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  overflow: hidden;
  padding-top: ${(p) => p.theme.spacing.getSize(3)};
`;

export const DetailsSection = styled.div`
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
`;

export const DetailSection = styled.div`
  padding: ${(p) => p.theme.spacing.getSize(4)};
  box-sizing: border-box;
  flex-shrink: 0;

  &:first-child {
    border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};
  }
`;

export const Footer = styled(Card)`
  position: fixed;
  bottom: 0;
  right: 0;
  height: 60px;
  width: calc(50% - ${(p) => p.theme.spacing.getSize(2)});
  max-width: calc(100vw - ${(p) => p.theme.spacing.getSize(8)});
  box-sizing: border-box;
  z-index: 10;
  display: flex;
  align-items: center;
  padding: ${(p) => p.theme.spacing.getSize(3)};
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: ${(p) => p.theme.spacing.getSize(3)};
`;

export const LeftButtons = styled.div`
  display: flex;
  gap: ${(p) => p.theme.spacing.getSize(2)};
`;

export const RightButtons = styled.div`
  display: flex;
  gap: ${(p) => p.theme.spacing.getSize(2)};
`;
